import React from 'react';
import logo from "../../assets/images/logo.png";
import {css} from "@emotion/css";

const AppBrand = () => {
    return (
        <div className="app-brand">
            <img
                src={logo}
                alt='raiko'
            />
            <span className={css`color: var(--color-text) !important;
                transition: var(--base-transition);`}>
                خبرگزاری آوای پرران
            </span>
        </div>
    )
}

export default AppBrand;